import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/GetAutoManagedCampaignById.graphql';
import { Query, QuerygetAutoManagedCampaignByIdArgs } from '../../__generated__/globalTypes';

export const useGetAutoManagedCampaignByIdQuery = (
  options?: QueryHookOptions<Query, QuerygetAutoManagedCampaignByIdArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerygetAutoManagedCampaignByIdArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useGetAutoManagedCampaignByIdLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerygetAutoManagedCampaignByIdArgs>
): QueryResult<Query, QuerygetAutoManagedCampaignByIdArgs> & {
  getGetAutoManagedCampaignById: LazyQueryExecFunction<Query, QuerygetAutoManagedCampaignByIdArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getGetAutoManagedCampaignById, result] = useLazyQuery<Query, QuerygetAutoManagedCampaignByIdArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getGetAutoManagedCampaignById, ...result };
};

export const useGetAutoManagedCampaignByIdPromiseQuery = () => {
  const client = useApolloClient();

  const getGetAutoManagedCampaignById = useCallback(
    (options?: Omit<QueryOptions<QuerygetAutoManagedCampaignByIdArgs, Query>, 'query'>) =>
      client.query<Query, QuerygetAutoManagedCampaignByIdArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getGetAutoManagedCampaignById };
};
// Suspense Query Hooks
export const useGetAutoManagedCampaignByIdSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerygetAutoManagedCampaignByIdArgs>
) => {
  const result = useSuspenseQuery<Query, QuerygetAutoManagedCampaignByIdArgs>(QUERY, {
    ...options
  });

  return result;
};
